import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig
} from '@angular/material/legacy-dialog';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SubscribeOfferNewsletterDialogComponent } from '../../../shared/modals/subscribe-offer-newsletter/subscribe-offer-newsletter.component';

@Component({
  selector: 'brf-news-newsletter-widget',
  templateUrl: './newsletter-widget.component.html',
  styleUrls: ['./newsletter-widget.component.scss']
})
export class NewsletterWidgetComponent implements OnInit {
  constructor(public dialog: MatDialog) {}
  emailControl = new UntypedFormControl();

  ngOnInit(): void {}

  submit() {
    const dialogConfig = new MatDialogConfig();
    //dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.maxHeight = '100vh';
    dialogConfig.data = {
      email: this.emailControl.value
    };
    this.dialog.open(SubscribeOfferNewsletterDialogComponent, dialogConfig);
  }
}
